import {RESET_AUTH_SIGN_PARAMS} from "../types";


const updateAuthSignParams= (usePAD) => async (dispatch) => {
  dispatch({type: RESET_AUTH_SIGN_PARAMS, payload: {auth: {params: {usePAD: usePAD}}}});
};
export default updateAuthSignParams;